import React, { useState } from "react";

import {
  Card,
  Cell,
  Collapse,
  Heading,
  IconButton,
  Layout,
  Page,
  Text,
  WixDesignSystemProvider,
} from "@wix/design-system";
import "@wix/design-system/styles.global.css";
import * as Icons from "@wix/wix-ui-icons-common";
import { withProviders } from "../../withProviders";
import faqs from "./faqs";
import "../index.css";
import TrialExpiryAlert from "../../../components/trial-expiry-alert";

const Index = () => {
  /*
  |--------------------------------------------------------------------------
  | States
  |--------------------------------------------------------------------------
  |
  */
  const [cardIndex, setCardIndex] = useState(null);
  const data = faqs;

  /*
  |--------------------------------------------------------------------------
  | Handle Toggle
  |--------------------------------------------------------------------------
  |
  */
  const handleToggle = (event: any, index: any) => {
    cardIndex === index ? setCardIndex(null) : setCardIndex(index);
  };

  return (
    <WixDesignSystemProvider>
      <Page height="95vh">
        <Page.Header
          title="FAQs"
          subtitle={
            <Text>Here is a quick guide to Frequently Asked Questions to help you navigate the application.</Text>
          }
        />
        <Page.Content>
          <TrialExpiryAlert />
          <Layout cols={12}>
            {data.map((item, index) => {
              return (
                <Cell key={item.id}>
                  <Card>
                    <div className="collapsible_card_header" onClick={(event) => handleToggle(event, index)}>
                      <Heading style={{ fontWeight: "bold" }} size="small">
                        {item.question}
                      </Heading>

                      <IconButton onClick={(event) => handleToggle(event, index)} skin={"light"}>
                        {cardIndex === index ? (
                          <Icons.ChevronUp color="black" />
                        ) : (
                          <Icons.ChevronDown color="black" />
                        )}
                      </IconButton>
                    </div>
                    <Card.Divider />
                    <Collapse open={cardIndex === index ? true : false}>
                      <Card.Content>
                        <Text>{item.answer}</Text>
                      </Card.Content>
                    </Collapse>
                  </Card>
                </Cell>
              );
            })}
          </Layout>
        </Page.Content>
      </Page>
    </WixDesignSystemProvider>
  );
};

export default withProviders(Index);
